// Copyright (c) Meta Platforms, Inc. and affiliates.

/**
 * @file groupStyles.ts
 * @input Uses StyleX, theme tokens
 * @output Exports shared group-aware styles for input components
 * @position Shared styles consumed by InputGroup-compatible controls
 */

import * as stylex from '@stylexjs/stylex';
import "../theme/tokens.stylex.js";
import { radiusVars, borderVars } from "../theme/tokens.stylex.js";
export const groupStyles = {
  inGroup: {
    kUk6DE: "x98rzlu",
    k7Eaqz: "xeuugli",
    kZKoxP: "x5yr21d",
    keTefX: "xd10s4z x1pwwqoy",
    krdFHd: "x15mokao x8eehn2",
    kVL7Gh: "xbiv7yw x1xrp5p4",
    kfmiAY: "x1ga7v0g x11xp8u1 xpufgd0 x1ir7nn6",
    kT0f0o: "x16uus16 x747jw7 xxd14kb x1vej5at",
    kXnDq0: "x1rm9qnc",
    $$css: true
  }
};